/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  valorDeTabelaUnidade: string;
  valorReaisDesconto: string | null;
  valorPorcentagemDesconto: string | null;
}

export function useAplicarDesconto(props: Props) {
  function toNumber(brNumber: string): number {
    const numberWithoutDots = brNumber.replace(/\./g, "");
    const numberWithDot = numberWithoutDots.replace(",", ".");
    return parseFloat(numberWithDot);
  }
  const putData = async () => {
    const APLICAR_DESCONTO = `${backofficeEnviroment}/common/oportunidades-lead/aplicar-desconto/vivaz/v1`;
    const { data } = await instance.put(APLICAR_DESCONTO, {
      valorDeTabelaUnidade:
        props.valorDeTabelaUnidade ?? toNumber(props.valorDeTabelaUnidade),
      valorReaisDesconto: props.valorReaisDesconto
        ? toNumber(props.valorReaisDesconto)
        : null,
      valorPorcentagemDesconto: props.valorPorcentagemDesconto
        ? toNumber(props.valorPorcentagemDesconto)
        : null,
    });
    return data;
  };

  const mutation = useMutation(putData, {
    onSuccess: () => {
      // toast.success("Resumo de pagamento inserido com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao aplicar desconto", error);
    },
  });

  return mutation;
}
